///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

export class TestMarkerView {
    private static readonly Z_INDEX = 1500;
    private marker: google.maps.marker.AdvancedMarkerElement;
    private contextMenuHandler: (e: MouseEvent) => void;

    constructor(
        private readonly coordinates: google.maps.LatLngLiteral,
        private readonly title: string
    ) {}

    draw(map: google.maps.Map): void {
        if (this.marker) {
            throw new Error('Marker is defined already');
        }

        this.marker = new google.maps.marker.AdvancedMarkerElement({
            map,
            position: this.coordinates,
            title: this.title,
            zIndex: TestMarkerView.Z_INDEX,
            gmpClickable: true
        });
    }

    hide(): void {
        if (!this.marker) {
            return;
        }

        google.maps.event.clearInstanceListeners(this.marker);
        if (this.contextMenuHandler) {
            this.marker.removeEventListener('contextmenu', this.contextMenuHandler);
        }

        this.marker.map = null;
        this.marker = undefined;
    }

    setPosition(position: google.maps.LatLngLiteral): void {
        this.marker.position = position;
    }

    getPosition(): google.maps.LatLngLiteral {
        return this.marker?.position as google.maps.LatLngLiteral;
    }

    registerClickListener(callback: (event: google.maps.MapMouseEvent) => void): void {
        this.marker?.addListener('click', callback);
    }

    registerRightClickListener(callback: (event: google.maps.MapMouseEvent) => void) {
        if (!this.marker) {
            return;
        }

        this.contextMenuHandler = (e) => {
            callback({
                latLng: new google.maps.LatLng(this.marker.position),
                stop: () => e.stopPropagation()
            } as google.maps.MapMouseEvent);
        };
        this.marker.addEventListener('contextmenu', this.contextMenuHandler);
    }
}
